module.exports = __webpack_public_path__ + "img/bg-portal.37d58c91.png";